import React, { useState } from "react";
import "./BatchCert.scss";
import Buttons from "../../components/ui/button/Buttons";
import CenterModel from "../../components/ui/centerModel/CenterModel";
import Select from "react-select";

const BatchCert = () => {
  const [showAcceptModal, setShowAcceptModal] = useState(false);
  const [poNumber, setPoNumber] = useState("");

  const openModal = () => {
    setShowAcceptModal(true);
  };

  const closeAcceptModal = () => {
    setShowAcceptModal(false);
    setPoNumber("");
  };

  const onApproveClick = () => {
    console.log("Submit clicked with PO:", poNumber);
    closeAcceptModal();
  };



  const Options = [
    { value: "1", label: "Yes" },
    { value: "2", label: "No" },
  ];


  return (
    <div className="batch-cert-page">
      {/* Top Search */}
      <div className="header">
        <label className="form-label">Search by Company Name</label>

        <div className="search-bar">
          <input
            type="text"
            placeholder="ABC Tech Pte Ltd"
            className="form-control input-field"
          />
          <Buttons buttonText="Search" buttonTypeClassName="success-btn" />
        </div>
      </div>

      {/* Main Content */}
      <div className="content-section">
        {/* Left Table */}
        <div className="table-section">
          <table>
            <thead>
              <tr>
                <th></th>
                <th>Company Name</th>
                <th>Included Certs</th>
                <th>Item Code</th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td>
                  <input type="checkbox" />
                </td>
                <td className="company ">ABC Tech Pte Ltd</td>
                <td>SGBC009</td>
                <td>CP10</td>
              </tr>

              <tr className="active">
                <td>
                  <input type="checkbox" />
                </td>
                <td className="company">ABC Tech Pte Ltd</td>
                <td>SGBC009/1</td>
                <td>CP11</td>
              </tr>

              <tr>
                <td>
                  <input type="checkbox" />
                </td>
                <td className="company">ABC Tech Pte Ltd</td>
                <td>SGBC009/2</td>
                <td>CP12</td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Right Form */}
        <div className="form-section">
          <div className="form-group">
            <label>Country</label>
            <input type="text" value="Australia" disabled />
          </div>

          <div className="form-group">
            <label>Overseas</label>
            <Select
              className="custom-checkbox-select"
              // value={props.value}
              // value={""} /
              options={Options}

            // onChange={props.onChange}
            // onBlur={props.onBlur}
            // options={props.options}
            // isMulti={props.isMultiSelect}
            // placeholder={props.placeholder}
            // isDisabled={true}
            />
          </div>

          <div className="form-group">
            <label>Invoice Approver</label>
            <Select
              className="custom-checkbox-select"
            // value={props.value}
            // value={""} /
            // options={Options}

            // onChange={props.onChange}
            // onBlur={props.onBlur}
            // options={props.options}
            // isMulti={props.isMultiSelect}
            // placeholder={props.placeholder}
            // isDisabled={true}
            />

          </div>

          <Buttons
            buttonText="Submit"
            buttonTypeClassName="btn submit-btn"
            onClick={openModal}
          />
        </div>
      </div>

      {/* Modal */}
      <CenterModel
        show={showAcceptModal}
        handleClose={closeAcceptModal}
        modelTitle="Invoice information will be pushed to Xero"
      >
        <p>Please enter a PO number, if applicable</p>

        <input
          type="text"
          className="form-control mt-2"
          value={poNumber}
          onChange={(e) => setPoNumber(e.target.value)}
        />

        <div className="d-flex justify-content-between gap-2 mt-4">
          <Buttons
            buttonText="Cancel"
            buttonTypeClassName="black-btn"
            onClick={closeAcceptModal}
          />
          <Buttons
            buttonText="Proceed"
            buttonTypeClassName="success-btn"
            onClick={onApproveClick}
          />
        </div>
      </CenterModel>
    </div>
  );
};

export default BatchCert;
